export default "__VITE_ASSET__6AZ884xG__"